import { Injectable } from '@angular/core';
import { NgxsOnInit, State, StateContext } from '@ngxs/store';
import { AudioDevicesSettingsState } from './local-storage-settings/audio-devices-settings.state';

// tslint:disable-next-line:no-empty-interface
export interface LocalStorageStateModel {}

@State<LocalStorageStateModel>({
   name: 'localStorage',
   defaults: {},
   children: [AudioDevicesSettingsState],
})
@Injectable()
export class LocalStorageState implements NgxsOnInit {
   ngxsOnInit(ctx?: StateContext<LocalStorageStateModel>) {
      // cleanup legacy local storage log state
      localStorage.removeItem('localStorageLogs');
   }
}
